import {
    PredefinedCommentValidationContext,
    PredefinedCommentValidationContextType,
} from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/contexts/predefined-comment-validation-form.context';
import { useContext } from 'react';

export const usePredefinedCommentValidationContext = (): PredefinedCommentValidationContextType => {
    const context = useContext(PredefinedCommentValidationContext);
    if (context === undefined) {
        throw new Error(
            'usePredefinedCommentValidationContext must be used within PredefinedCommentValidationProvider'
        );
    }
    return context;
};
